import axios from "axios";
export default {
    downloadOntologicalModel: () => axios.post("/OntologicalModel/DownloadOntologicalModel"),
    uploadOntologicalModel: (file) => {
        const formData = new FormData();
        formData.append("File", file, file.name);
        return axios.post("/OntologicalModel/UploadOntologicalModel", formData);
    },
    getOntologicalModel: () => axios.post("/OntologicalModel/GetOntologicalModel"),
    saveOntologicalModel: (data) => axios.post("/OntologicalModel/SaveOntologicalModel", data),
    reloadOntology: (signalRConnectionId) => axios.post("/Settings/ReloadOntology", { signalRConnectionId }),
    exportOntology: () => axios.post("/Settings/ExportOntologyToTfm")
};
